import React from "react";
import AsyncSelect from "react-select/async";
const index = ({ setSalesAreas }) => {
	const salesAreas = [
		"Artavia",
		"Cinco Ranch #2",
		"Jersey Village 3",
		"Katy North #3",
		"Ladera",
		"Rio Rancho #1",
		"Remington Ranch",
		"Katy South #7",
		"Katy South #6",
	];

	return (
		<AsyncSelect
			isMulti
			cacheOptions
			defaultOptions={salesAreas.map((salesArea) => ({
				label: salesArea,
				value: salesArea,
			}))}
			loadOptions={(inputValue, callback) => {
				// Simple filter for demonstration; replace with API call if needed
				const filtered = salesAreas
					.filter((salesArea) =>
						salesArea.toLowerCase().includes(inputValue.toLowerCase()),
					)
					.map((salesArea) => ({
						label: salesArea,
						value: salesArea,
					}));
				callback(filtered);
			}}
			onChange={(selectedOptions) => {
				// selectedOptions is an array of { label, value }
				setSalesAreas(
					selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
				);
			}}
			classNamePrefix={"async_select"}
			placeholder="Select Sales Area(s)"
		/>
	);
};

export default index;
